import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpHeaders,
    HttpInterceptor, HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import * as moment_ from 'moment';
const moment = moment_;
import {catchError, tap} from 'rxjs/operators';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private cookieService: CookieService,
        private translateService: TranslateService,
        private notification: NzNotificationService,
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.getToken();
        const header = {};
        if (token) {
            header['authorization'] = 'Bearer ' + token;
        }
        const authReq = request.clone({
            headers: new HttpHeaders(header)
        });

        return next.handle(authReq).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.code !== 0) {
                        if (event.body.message) {
                            this.notification.create('error', event.body.message, '');
                        }
                    }
                }
            }),
            catchError((error: any) => {
                if (error.status === 401 && !request.url.includes('/login')) {
                    this.notification.create('error', this.translateService.instant('登录信息过期'), this.translateService.instant('请重新登录!'));
                    this.router.navigate(['/login']);
                }
                return throwError(error);
            })
        );
    }

    getToken(): string {
        const token = this.cookieService.get('token');
        if (token) {
            this.cookieService.set('token', token, moment().add(30, 'm').toDate());
            return token;
        } else {
            return '';
        }
    }
}
